import { Controller } from 'stimulus';

class ItalyMapController extends Controller {
  connect() {
    this.urls = JSON.parse(this.data.get('urls'));

    if (!this.urls) return;

    this.regions = this.regionTargets
      .map((region) => {
        region.url = this.urls[region.parentNode.id];

        return region;
      })
      .filter((region) => region.url);

    this.regions.forEach((region) => {
      region.addEventListener('click', this.onRegionClick.bind(this, region.url));
      region.addEventListener('mouseenter', this.onRegionMouseEnter.bind(this));
      region.addEventListener('mouseleave', this.onRegionMouseLeave.bind(this));
    });
  }

  disconnect() {
    this.regions.forEach((region) => {
      region.removeEventListener('click', this.onRegionClick.bind(this, region.url));
      region.removeEventListener('mouseenter', this.onRegionMouseEnter.bind(this));
      region.removeEventListener('mouseleave', this.onRegionMouseLeave.bind(this));
    });
  }

  onRegionMouseEnter({ target }) {
    target.style.filter = 'brightness(120%)';
    target.style.cursor = 'pointer';
  }

  onRegionMouseLeave({ target }) {
    target.style.filter = 'none';
  }

  onRegionClick(url) {
    window.location.href = url;
  }
}

ItalyMapController.targets = [
  'region',
];

export default ItalyMapController;
